import { observable, computed, action } from "mobx"
import { firebase } from "./constants"
import authStore from "./auth/auth-store"

function scaleTo({ top, left, width, height }, scale) {
  return {
    top: top * scale,
    left: left * scale,
    width: width * scale,
    height: height * scale,
  }
}

class CreateStore {
  @action.bound
  createProduct(config, files, dimensions) {
    const productKey = firebase
      .database()
      .ref("stores")
      .child(authStore.userStoreId)
      .child("products")
      .push().key
    // const productKey = 1
    this.saveProductConfig(productKey, config)
    this.queueProductFiles(productKey, files, dimensions)
  }

  saveProductConfig(id, data) {
    const payload = {
      name: data.name,
      profit: data.profit,
      product_id: data.product_id,
      variant_ids: data.variant_ids,
    }
    console.log("saveProductConfig", payload)
    firebase
      .database()
      .ref("stores")
      .child(authStore.userStoreId)
      .child("products")
      .child(id)
      .set(payload)
  }

  queueProductFiles(id, files = [], dimensions) {
    const payload = {
      userId: authStore.userId,
      storeId: authStore.userStoreId,
      productId: id,
      images: files.reduce((images, file) => {
        return {
          ...images,
          [file.id]: {
            name: file.id,
            url: file.url,
            sizes: dimensions.map(dimension => {
              const [x, y] = dimension.split("x")
              const scale = x * 200 / file.printarea.width
              return {
                name: dimension,
                width: x * 200,
                height: y * 200,
                overlay: scaleTo(file.design, scale),
              }
            }),
          },
        }
      }, {}),
    }
    console.log("queueProductFiles", payload)
    firebase
      .database()
      .ref("processImageQueue")
      .push(payload)
  }
}

export default new CreateStore()



// WEBPACK FOOTER //
// ./src/create-store.js